import { Select } from "antd";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 120px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const FilterSelectInput = styled(Select)`
  &.ant-select {
    border-radius: 10px;
    width: ${(props) => props?.filterlenght};
    overflow: hidden;
    border: 1px solid gainsboro;
    width: 330px;
    box-shadow: 5px 0px 10px 0px rgba(0, 0, 0, 0.15);

    .ant-select-selector {
      border: none;
      outline: none;
      height: 30px;
      .ant-select-selection-search {
        .ant-select-selection-search-input {
          outline: none;
          border: none;
        }
      }
      .ant-select-selection-item {
        display: flex;
        font-size: 14px;
        width: 100%;
      }
    }
  }
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.15);
`;

export const Wrapper = styled.div`
  display: flex;
  height: ${({ havePermission }) =>
    havePermission === true ? "calc(100vh - 305px)" : "calc(100vh - 265px)"};
  margin-top: 30px;
  overflow: scroll;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FixedColumn = styled.div`
  background: #e6e6e6;
  position: sticky;
  left: 0;
  z-index: 20;
`;

export const ScrollableWrapper = styled.div`
  overflow: auto;
  flex: 1;
  position: relative;
  
  /* Hide scrollbars for all browsers */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  
  /* Webkit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 4px;
  width: 100%;
  /* background: #ffffff !important; */
 
 thead {
   position: relative;
 }
`;

export const BackgroudThead = styled.div`
  background-color: #e6e6e6;
  position: fixed;
  width: 500px;
  height: 65px;  
  z-index: 25;
  top: ${({ havePermission }) => havePermission ? "220px" : "185px"};
  left: 5px;
`;

export const Thead = styled.div`
  position: sticky;
  top: 0px;
  /* background: #ffffff !important; */
  z-index: 55;
  margin-bottom: 2px;
`;

export const Thead2 = styled.div`
  width: 100%;
  /* background: #ffffff; */
  position: sticky;
  top: 0px;
  z-index: 15;
  display: flex;
`;

export const TbodyNames = styled.tbody`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Tbody = styled.tbody`
  display: flex;
  flex-direction: column;
`;

export const DaysInMonth = styled.th`
  border: 1px solid #c5c5c5;
  padding: ${({ isNextMonth }) => (isNextMonth ? "6px 0" : "6px")};
  text-align: center;
  font-size: 12px;
  height: 50px !important;
  min-height: 50px !important;
  overflow: hidden;
  border-radius: 10px;
  min-width: 40px !important;
  width: 40px !important;
  transition: all 0.3s ease;
  background-color: #e6e6e6 !important;
  position: sticky;
  top: 0;
  z-index: 30;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &[data-weekend="true"] {
    filter: brightness(0.8) saturate(2);
    background-color: #d0d0d0 !important;
  }
`; 

export const Th = styled.th`
  border: 1px solid #c5c5c5;
  padding: ${({ isNextMonth }) => (isNextMonth ? "6px 0" : "6px")};
  text-align: center;
  font-size: 12px;
  height: 61px !important;
  min-height: 61px !important;
  overflow: hidden;
  border-radius: 10px;
  min-width: 40px !important;
  width: 40px !important;
  background-color: #f8f9fa;
  transition: all 0.3s ease;

  &[data-weekend="true"] {
    filter: brightness(0.8) saturate(2);
  }
`;

export const ThHour = styled.div`
  border: 1px solid #c5c5c5;
  padding: 6px;
  text-align: center;
  height: 50px;
  width: 61px !important;
  min-width: 110px !important;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: #ffffff;
`;

export const TdName = styled.th`
    border: 1px solid #c5c5c5;
  /* padding: ${({ isNextMonth }) => (isNextMonth ? "6px 0" : "6px")}; */
  text-align: center;
  /* font-size: 12px; */
  height: 50px !important;
  min-height: 50px !important;
  overflow: hidden;
  border-radius: 10px;
  min-width: 110px !important;
  width: 110px !important;
  transition: all 0.3s ease;
  font-weight: 500;
  background-color: #e6e6e6;
  position: sticky;
  /* top: 0; */
  z-index: 50;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &.shift-manager {
    background-color: #f6c8bd;
  }

  &.satco {
    background-color: #f6c8bd;
  }
  &.superintendent {
    background-color: #dc7e72;
  }
  &.student {
    background-color: #95dea8;
  }
`;

export const Td = styled.td`
  border: 1px solid #c5c5c5;
  padding: 6px;
  text-align: center;
  height: 61px;
  width: 40px;
  min-width: 40px;
  border-radius: 10px;
  background-color: #efefef;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  
  &[data-weekend="true"] {
    filter: brightness(0.8) saturate(2);
  }
`;

export const Tr = styled.tr`
  &.current-user {
    background-color: #bdbfc1 !important;
  }
`;

export const BadgeSymbol = styled.div`
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: 10px;
  right: 8px;
  color: RGBA(0, 0, 0, 0.3);
  & div > div > svg {
    width: 12px;
  }
`;

export const DateHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const DateNumber = styled.div`
  color: black;
  font-weight: 600;
  font-size: 12px;
`;

export const WeekdayName = styled.div`
  color: black;
  font-size: 10px;
  font-weight: 400;
`;

export const TextFooter = styled.div`
  font-size: 21px;
  align-self: center;
  color: ${({ theme: { colors } }) => colors.grayColors.lightGray};
  font-weight: 600;
`;

export const TextFooterVersion = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin-top: -8px;
  opacity: 0.6;
  text-transform: uppercase;
  text-align: center;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: center;
  width: 100%;
  height: 55px;
  z-index: 1;
  background-color: ${({ theme: { colors } }) => colors.mainColors.blue};
  margin-top: 20px;
 
 /* Safe area for phone navigation buttons */
 padding-bottom: env(safe-area-inset-bottom);
 padding-bottom: constant(safe-area-inset-bottom);
 
 /* Fallback for devices without safe area support */
 @media screen and (max-height: 700px) {
   padding-bottom: 20px;
 }
 
 @media screen and (max-height: 600px) {
   padding-bottom: 30px;
 }
`;